var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto"},[_c('iframe',{attrs:{"height":"200","src":_vm.href,"title":"YouTube video player","frameborder":"0","allow":"","allowfullscreen":""}}),_c('v-card-title',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }